<template>

<div v-if="state.phone!=-1">
  
  <div class="home">
    <div class="top_bg">
      <div class="fcj_lr">
        <div class="fcj_ll">
          <div>
            <div class="header"><img :src="state.header" alt=""></div>
          </div>
          <div>
            <div class="home_name">{{state.name}}</div>
            <div class="home_card">会员卡：{{state.phone}}</div>
          </div>
        
        </div>
        <div class="icon-qr" @click="linkto('/myqr?id='+state.uid)"><van-icon name="qr" /></div>
      </div>
    </div>
    <img style="width:100%;" src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iNTAiIHZlcnNpb249IjEuMSIgIHN0eWxlPSJ3aWR0aDoxMDAlIj4KICAgICAgPHBhdGggZD0iTTAgMCBxIDE1MCA1MCwzMDAgMCBaIiBmaWxsPSIjMDA3ZGUwIiAvPgogICAgPC9zdmc+" alt="">
    
    <div class="home_content">
      <div class="detail">
        <div class="detail_body">
          <div class="fcj_lb center">
            <div>
              <div class="tbn">{{state.bi}}</div>
              <div>积分</div>
            </div>
            <div>
              <div class="tbn">{{state.levelname}}</div>
              <div>会员等级</div>
            </div>
            <div @click="linkto('/mycardlist/')">
              <div class="tbn">{{state.card_count}}</div>
              <div>卡券数量</div>
            </div>
          </div>
        </div>
      </div>



      <div class="card" @click="linkto('mycardinfo/?id='+item.cid)" v-for="(item,index) in state.card" :key="index">
        <div><img :src="state.path+item.fpath" class="cardpic" alt=""></div>
        <div class="cardname">{{item.cardname}}</div>
        <div class="carddate">有效期：{{item.start_time}} ~ {{item.end_time}}</div>
      </div>


      <div class="detail">
        <div class="detail_body">
          <div class="fcj_lb center">
            <div @click="outlink()">
              <div class="flxu" style="color:#52acaa"><van-icon name="shield-o" /></div>
              <div>我的质保单</div>
            </div>
            <div>
              <div class="flxu" style="color:#e7595f"><van-icon name="smile-o" /></div>
              <div>专属顾问</div>
            </div>
            <div @click="linkto('userset')">
              <div class="flxu" style="color:#418be2"><van-icon name="setting-o" /></div>
              <div>个人设置</div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="detail" v-if="state.userinfo!=''&state.userinfo.role>1">
        <div style="height: 80px;line-height: 80px; text-align: center;font-size:20px;" @click="linkto('fanshen')">申请返审</div>
      </div> -->

      
    </div>
  </div>
</div>
</template>

<script>
// @ is an alias to /src

import { reactive,onMounted,ref } from 'vue';
import { useRouter } from 'vue-router';
import ajax from '@/assets/public.js'
import wx from 'weixin-js-sdk';

import { Toast,Icon,Button,Cell, CellGroup,Form,Field } from 'vant';

export default {
  name: 'HomeView',
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Toast.name]: Toast
  },
  setup(){

    const router=useRouter();
    const state=reactive({
      uid:'',
      path:'',
      phone:'-1',
      header:ajax.path+'images/no_header.png',
      bi:0,
      card_count:0,
      levelname:'',
      userinfo:{}
    })
    var url=window.location.href.split('#')[0];

    ajax.req({
      url: 'wxapi/?ajax='+encodeURIComponent(url)+'&path=index',
      data: {},
    }).then(res => {
      wx.config({
          debug: false,
          appId: res.appid,
          timestamp: res.t,
          nonceStr: res.r,
          signature: res.s,
          jsApiList: ['updateTimelineShareData','updateAppMessageShareData']
      });
      wx.ready(function(){	
        wx.updateAppMessageShareData({
              title: res.title,
              desc: res.desc,
              link: url,
              imgUrl:ajax.path+"images/share.jpg",
              success: function () {},
          });
          wx.updateTimelineShareData({
              title:res.title,
              link: url,
              imgUrl:ajax.path+"images/share.jpg",
              success: function () {},
          });
      })
    })

    onMounted(() => {
      state.path=ajax.path
      getdata()
    })

    function onSubmit(v){
      if(loading.value==false){
        loading.value=true;
        var openid=localStorage.getItem("openid");
        ajax.req({
          url: 'myinfo/',
          data: {
            'do': 'update',
            'phone':v.phone,
            'openid':openid
          },
        }).then(res => {
          loading.value=false;
          if(res.error>0){
            if(res.error==2){
              localStorage.clear();
              window.location.reload();
            }else{
              Toast({
                message: res.msg,
                position: 'top',
              });
            }
          }else{
            if(res.msg=='success'){
              localStorage.removeItem('weixinregist');
              localStorage.removeItem('openid');
              localStorage.setItem('pusern',res.data)
            }
            
            getdata();
          }
          
        });
      }
    }

    function getdata(){
      ajax.req({
        url: '/',
        data: {},
      }).then(res => {
        if(res.data.user[0]<=0&&!localStorage.getItem('weixinregist')){

          localStorage.setItem("backurl",window.location.href);
          window.location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ajax.appid+'&redirect_uri='+encodeURIComponent(ajax.oauth)+'&response_type=code&scope=snsapi_base&state=1#wechat_redirect';
    
        }
        state.uid=res.data.user.id
        state.phone=res.data.user.phone
        state.name=res.data.user.usern
        state.header=res.data.user.logo

        state.card_count=res.data.cardnumber
        state.bi=res.data.user.bi
        state.levelname=res.data.user.levelname
        state.userinfo=res.userinfo
      });
    }
    function outlink(){
      window.location.href=ajax.dan;
    }
    function linkto(v){
      router.push(v)
    }
    function cls(){
      localStorage.clear();
    }
    const loading=ref(false);

    return {
      state,
      ajax,
      cls,
      loading,
      outlink,
      onSubmit,
      linkto
    }
  }
}
</script>
